<template>
  <div class="relative flex items-center">
    <woot-button
      variant="smooth"
      class="absolute left-0 top-5 z-10 h-[2.45rem] w-[2.45rem] p-0 !text-gray-400 dark:!bg-gray-900 dark:!text-gray-600 [&>span]:flex [&>span]:items-center [&>span]:justify-center"
      color-scheme="secondary"
      @click="toggleEmojiPicker"
    >
      <span v-if="icon" v-dompurify-html="icon" class="text-lg" />
      <fluent-icon
        v-else
        size="18"
        icon="emoji-add"
        type="outline"
        class="text-gray-400 dark:text-gray-600"
      />
    </woot-button>
    <woot-input
      v-model="name"
      :class="{ error: hasError }"
      class="relative !mx-0 !mb-4 !mt-0 w-[calc(100%-3rem)] [&>input]:!mb-0 ltr:[&>input]:ml-12 rtl:[&>input]:mr-12 [&>p]:w-max"
      :error="nameErrorMessage"
      :label="label"
      :placeholder="placeholder"
      :help-text="helpText"
      @input="onNameChange"
    />
    <emoji-picker
      v-if="showEmojiPicker"
      v-on-clickaway="hideEmojiPicker"
      :left="0"
      :top="60"
      :max-height="300"
      @emoji-click="onClickInsertEmoji"
    />
  </div>
</template>

<script>
const EmojiPicker = () => import('shared/components/EmojiPicker.vue');

export default {
  components: { EmojiPicker },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    existingName: {
      type: String,
      default: '',
    },
    savedIcon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
      icon: '',
      showEmojiPicker: false,
    };
  },
  computed: {
    nameErrorMessage() {
      if (this.hasError) {
        return this.errorMessage;
      }
      return '';
    },
  },
  mounted() {
    this.updateDataFromStore();
  },
  methods: {
    updateDataFromStore() {
      this.name = this.existingName;
      this.icon = this.savedIcon;
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    onClickInsertEmoji(emoji = '') {
      this.icon = emoji;
      this.$emit('icon-change', emoji);
      this.showEmojiPicker = false;
    },
    onNameChange() {
      this.$emit('name-change', this.name);
    },
    hideEmojiPicker() {
      if (this.showEmojiPicker) {
        this.showEmojiPicker = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
